import houndredImg from "../picture/Houndred.png";
import redStar from "../picture/StarRed.png";
import nElement from "../picture/NElement.png";
import leftPadding from "../picture/LeftPadding.png";
import centralPadding from "../picture/centralPadding.png";
import blackStarImg from "../picture/blackStar.png";
import fiftyImg from "../picture/Fifty.png";
import playLeft from "../picture/play-left.png";
import playRight from "../picture/play-right.png";
import plus from "../picture/Plus.png";
import middleArrowParagrafhImg from "../picture/MiddleArrowParagrafh.png";
import middleParagrafhImg from "../picture/middleParagrafh.png";
import forParagrafhImg from "../picture/ForParagrafh.png";
import { useEffect, useState } from "react";
import axios from "axios";
import { useGlobalContext } from "../Context/Context.js";
import titleStyle1 from "../picture/16.1.png";
import titleStyle2 from "../picture/16.2.png";
import titleStyle3 from "../picture/16.3.png";
import border1 from "../picture/17.1.png";
import border2 from "../picture/17.2.png";
import requiredPosition1 from "../picture/18.1.png";
import requiredPosition2 from "../picture/18.2.png";
import minus from "../picture/minus.png";
import text3Img from "../picture/text3.png";
import Button from "../AdminPanel/Custom/Button/Button.jsx";

const FieldSettingsEditor = (location_input, data) => {
  const [fieldsData, setFieldsData] = useState([])
  const [currentIndex, setCurrentIndex] = useState(0)

  const { baseUrl, loggedUser, apiKey, chooseObject } = useGlobalContext();

  console.log(location_input);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(`https://data.nadzor.app/api/items/readAllFields.php`, {
          api_key: apiKey, location_id: location_input.location_input
        });

        setFieldsData(response.data.data.fields);
      } catch (err) {
        // setError(err);
      }
    };

    fetchData();
  }, []);

  const updateSettings = async () => {
    try {
      await axios.post('https://data.nadzor.app/api/items/updateField.php', {
        ...fieldsData[currentIndex],
        api_key: apiKey
      });
    } catch (err) {
      console.error('Error saving settings:', err);
    }
  };

  const createNewField = async () => {
    try {
      const response = await axios.post('https://data.nadzor.app/api/items/createNewField.php', {
        location_id: location_input.location_input, api_key: apiKey
      });
      setFieldsData(prev => [...prev, response.data.data])
      setCurrentIndex(fieldsData.length)
    } catch (err) {
      console.error('Error creating field:', err);
    }
  }
  const deleteField = async () => {
    try {
      await axios.post('https://data.nadzor.app/api/items/deleteField.php', {
        field_id: fieldsData[currentIndex].id, api_key: apiKey
      });
      setFieldsData(prev => prev.filter(field => field.id != fieldsData[currentIndex].id))
      setCurrentIndex(0)
    } catch (err) {
      console.error('Error creating field:', err);
    }
  }

  const handlePrevious = () => {
    setCurrentIndex(Math.max(0, currentIndex - 1))
  }
  const handleNext = () => {
    setCurrentIndex(Math.min(fieldsData.length - 1, currentIndex + 1))
  }

  const handleChangeName = (e) => {
    const copyFields = [...fieldsData]
    copyFields[currentIndex].name = e.target.value
    setFieldsData(copyFields)
  }

  const handleChangeCheckbox = async (e) => {    
    const copyFields = [...fieldsData]
    copyFields[currentIndex][e.target.name] = e.target.checked
    setFieldsData(copyFields)
    await updateSettings()
  }
  const handleSetValue = async (value, name) => {
    if (value == fieldsData[currentIndex][name]) return

    const copyFields = [...fieldsData]
    copyFields[currentIndex][name] = value
    setFieldsData(copyFields)
    await updateSettings()
  }

  if (fieldsData.length === 0) return <></>

  return (
    <>
      <div style={{display: "flex", gap: "30px"}}>
        <div className="se-segment3">
          <div className="se-segment3-1" style={{fontSize: "18px"}}>
            <div
              style={{
                display: "flex",
                justifyContent: fieldsData[currentIndex].title_justify == 1 ? "start" : "center",
                backgroundColor: fieldsData[currentIndex].title_style == 2 ? "lightgrey" : "transparent",
                border: fieldsData[currentIndex].title_style == 3 ? "1px solid black" : "none",
                padding: "4px"
              }}
              className="se-segment3-1-header"
            >
              XXXXXXXX
            </div>
            <div
              style={{display: "flex", flexDirection: "column", padding: "3px",
                alignItems: fieldsData[currentIndex].content_justify == 1 ? "start" : "center",
                border: fieldsData[currentIndex].border == 1 ? "none" : "1px solid black"
              }}
              className="se-segment3-1-content"
            >
              <div style={{textIndent: fieldsData[currentIndex].content_indent ? "20px" : 0}}>Xxxxx xxx xxxx xx xxxxxxxx xx</div>
              <div>xxxxx. Xxxxxxxx xxxx</div>
            </div>
          </div>

          {fieldsData[currentIndex].title_visible && <div className="se-segment3-2-header">
            {fieldsData[currentIndex].field_required && fieldsData[currentIndex].required_position == 2 &&
              <div style={{color: fieldsData[currentIndex].required_visible == 1 ? "red" : "black"}} className="se-segment3-2-header-zvezdica">*</div>
            }
            <div
              style={{
                display: "flex",
                justifyContent: fieldsData[currentIndex].title_justify == 1 ? "start" : "center",
                backgroundColor: fieldsData[currentIndex].title_style == 2 ? "lightgrey" : "transparent",
                border: fieldsData[currentIndex].title_style == 3 ? "1px solid black" : "none"
              }}
              className="se-segment3-2-header-text"
            >
              {fieldsData[currentIndex].name}
              <div className="se-segment3-2-header-16" style={{backgroundColor: "white"}}>16</div>
            </div>
            {fieldsData[currentIndex].field_required && fieldsData[currentIndex].required_position == 1 &&
              <div style={{color: fieldsData[currentIndex].required_visible == 1 ? "red" : "black"}} className="se-segment3-2-header-zvezdica">*</div>
            }
            <div className="se-segment3-2-header-18">18</div>
          </div>}
          <div className="se-segment3-2-content-div">
            <textarea 
              style={{
                textAlign: fieldsData[currentIndex].content_justify == 1 ? "left" : "center",
                textIndent: fieldsData[currentIndex].content_indent ? "20px" : 0,
                border: fieldsData[currentIndex].border == 1 ? "none" : "1px solid black"
              }}
              className="se-segment3-2-content"
              rows={4} defaultValue={"Xxxxx"}
            >
            </textarea>
            <div className="se-segment3-2-header-17">17</div>
          </div>

          <div className="se-segment3-checkbox">
            <div className="one-checbox">
              <input
                type="checkbox"
                name="title_visible"
                checked={fieldsData[currentIndex].title_visible}
                onChange={handleChangeCheckbox}
              />
              <div className="num-checkbox">16</div>
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                name="field_required"
                checked={fieldsData[currentIndex].field_required}
                onChange={handleChangeCheckbox}
              />
              <div className="num-checkbox">18</div>
            </div>
            <div className="one-input">
              <input value={fieldsData[currentIndex].name} onChange={handleChangeName} style={{padding: "3px 5px"}}/>
            </div>
            <div onClick={updateSettings}>
              <Button className="one-checbox dos-btn" activation={true}>
                POTVRDI
              </Button>
            </div>
          </div>
          <div className="se-segment3-checkbox" style={{ gap: "unset", justifyContent: "space-between" }}>
            <div className="num-checkbox">16</div>
            <div className="one-checbox">
              <input
                type="checkbox"
                name="title_style"
                checked={fieldsData[currentIndex].title_style == 1}
                onChange={() => handleSetValue(1, "title_style")}
              />
              <img src={titleStyle1} alt="" style={{ height: "20px" }} />
            </div>

            <div className="one-checbox">
              <input
                type="checkbox"
                name="title_style"
                checked={fieldsData[currentIndex].title_style == 2}
                onChange={() => handleSetValue(2, "title_style")}
              />
              <img src={titleStyle2} alt="" style={{ height: "20px" }} />
            </div>

            <div className="one-checbox">
              <input
                type="checkbox"
                name="title_style"
                checked={fieldsData[currentIndex].title_style == 3}
                onChange={() => handleSetValue(3, "title_style")}
              />
              <img src={titleStyle3} alt="" style={{ height: "20px" }} />
            </div>

            <div className="one-checbox">
              <input
                type="checkbox"
                name="title_justify"
                checked={fieldsData[currentIndex].title_justify == 1}
                onChange={() => handleSetValue(1, "title_justify")}
              />
              <img src={leftPadding} alt="" style={{ height: "20px" }} />
            </div>

            <div className="one-checbox">
              <input
                type="checkbox"
                name="title_justify"
                checked={fieldsData[currentIndex].title_justify == 2}
                onChange={() => handleSetValue(2, "title_justify")}
              />
              <img src={centralPadding} alt="" style={{ height: "20px" }} />
            </div>
          </div>

          <div className="se-segment3-checkbox" style={{ gap: "unset", justifyContent: "space-between" }}>
            <div style={{ display: "flex", gap: "10px" }}>
              <div className="num-checkbox">18</div>
              <div className="one-checbox">
                <input
                  type="checkbox"
                  name="required_position"
                  checked={fieldsData[currentIndex].required_position == 1}
                  onChange={() => handleSetValue(1, "required_position")}
                />
                <img src={requiredPosition1} alt="" style={{ height: "20px" }} />
              </div>

              <div className="one-checbox">
                <input
                  type="checkbox"
                  name="required_position"
                  checked={fieldsData[currentIndex].required_position == 2}
                  onChange={() => handleSetValue(2, "required_position")}
                />
                <img src={requiredPosition2} alt="" style={{ height: "20px" }} />
              </div>
            </div>

            <div style={{ display: "flex", gap: "10px" }}>
              <div className="one-checbox">
                <input
                  type="checkbox"
                  name="required_visible"
                  checked={fieldsData[currentIndex].required_visible == 1}
                  onChange={() => handleSetValue(1, "required_visible")}
                />
                <img src={redStar} alt="" style={{ height: "15px" }} />
              </div>

              <div className="one-checbox">
                <input
                  type="checkbox"
                  name="required_visible"
                  checked={fieldsData[currentIndex].required_visible == 2}
                  onChange={() => handleSetValue(2, "required_visible")}
                />
                <img src={blackStarImg} alt="" style={{ height: "15px" }} />
              </div>
            </div>
          </div>

          <div className="se-segment3-checkbox" style={{ gap: "unset", justifyContent: "space-between" }}>
            <div className="num-checkbox" style={{ color: "green" }}>17</div>
            <div className="one-checbox">
              <input
                type="checkbox"
                name="max_characters"
                checked={fieldsData[currentIndex].max_characters == "100"}
                onChange={() => handleSetValue("100", "max_characters")}
              />
              <img src={houndredImg} alt="" style={{ height: "15px" }} />
            </div>

            <div className="one-checbox">
              <input
                type="checkbox"
                name="max_characters"
                checked={fieldsData[currentIndex].max_characters == "500"}
                onChange={() => handleSetValue("500", "max_characters")}
              />
              <img src={fiftyImg} alt="" style={{ height: "15px" }} />
            </div>

            <div className="one-checbox">
              <input
                type="checkbox"
                name="max_characters"
                checked={fieldsData[currentIndex].max_characters == "N"}
                onChange={() => handleSetValue("N", "max_characters")}
              />
              <img src={nElement} alt="" style={{ height: "15px" }} />
            </div>

            <div className="one-checbox">
              <input
                type="checkbox"
                name="content_justify"
                checked={fieldsData[currentIndex].content_justify == 1}
                onChange={() => handleSetValue(1, "content_justify")}
              />
              <img src={leftPadding} alt="" style={{ height: "20px" }} />
            </div>

            <div className="one-checbox">
              <input
                type="checkbox"
                name="content_justify"
                checked={fieldsData[currentIndex].content_justify == 2}
                onChange={() => handleSetValue(2, "content_justify")}
              />
              <img src={middleParagrafhImg} alt="" style={{ height: "20px" }} />
            </div>
          </div>

          <div className="se-segment3-checkbox" style={{ gap: "unset", justifyContent: "space-between", marginLeft: "38px" }}>
            <div className="one-checbox">
              <input
                type="checkbox"
                name="content_rows"
                checked={fieldsData[currentIndex].content_rows == 1}
                onChange={() => handleSetValue(1, "content_rows")}
              />
              <img src={forParagrafhImg} alt="" style={{ height: "15px" }} />
            </div>

            <div className="one-checbox">
              <input
                type="checkbox"
                name="content_rows"
                checked={fieldsData[currentIndex].content_rows == 2}
                onChange={() => handleSetValue(2, "content_rows")}
              />
              <img src={nElement} alt="" style={{ height: "15px" }} />
            </div>

            <div className="one-checbox">
              <input
                type="checkbox"
                name="border"
                checked={fieldsData[currentIndex].border == 1}
                onChange={() => handleSetValue(1, "border")}
              />
              <img src={border1} alt="" style={{ height: "20px" }} />
            </div>

            <div className="one-checbox">
              <input
                type="checkbox"
                name="border"
                checked={fieldsData[currentIndex].border == 2}
                onChange={() => handleSetValue(2, "border")}
              />
              <img src={border2} alt="" style={{ height: "20px" }} />
            </div>

            <div className="one-checbox">
              <input
                type="checkbox"
                name="content_indent"
                checked={fieldsData[currentIndex].content_indent}
                onChange={handleChangeCheckbox}
              />
              <img src={middleArrowParagrafhImg} alt="" style={{ height: "20px" }} />
            </div>
          </div>

        </div>
        <div>
          <img src={text3Img} style={{width: "100%", height: "320px"}}/>
          <div className="se-segment3-buttons">
            <img src={playLeft} onClick={handlePrevious}/>
            <Button activation={true} className="dos-btn" style={{width: "80px", height: "80px"}}><img src={minus} onClick={deleteField} style={{width: "60px", height: "60px"}}/></Button>
            <Button activation={true} className="dos-btn" style={{width: "80px", height: "80px"}}><img src={plus} onClick={createNewField} style={{width: "60px", height: "60px"}}/></Button>
            <img src={playRight} onClick={handleNext}/>
          </div>
        </div>
      </div>
    </>
  );
};

export default FieldSettingsEditor;